import React from 'react'
import HeroSection from '../../Components/home/HeroSection'
import OurCoreSectors from '../../Components/home/OurCoreSectors'
import WhyChooseUs from '../../Components/home/WhyChooseUs'
import OurClientele from '../../Components/home/OurClientele'
import EmpanelmentsAuthorisation from '../../Components/home/EmpanelmentsAuthorisation'
import MajorProjects from '../../Components/home/MajorProjects'
import SubscribeTo from '../../Components/home/SubscribeTo'
import SwiperHero from '../../Components/home/SwiperHero'

const Home = () => {
  return (
    <div className='overflow-x-hidden tracking-wide'>
      {/* <HeroSection/> */}
      <SwiperHero/>
      <OurCoreSectors/>
      <WhyChooseUs/>
      <OurClientele/>
      <EmpanelmentsAuthorisation/>
      <MajorProjects/>
      <SubscribeTo/>
    </div>
  )
}

export default Home